import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

const _get = async (queryParamFilters, queryParam, setParams, setMetadata) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  setParams?.(params)

  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: '/sales-order',
    params: params,
  })

  setMetadata?.(response?.data.metadata)

  return response?.data
}

export const get = (queryParamFilters, setParams, setMetadata) => async (queryParam) =>
  await _get(queryParamFilters, queryParam, setParams, setMetadata)

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/sales-order/${id}`,
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/sales-order',
    data,
  })

  return response?.data
}

export const update = async (id, data) => {
  const response = await apiClientV2({
    method: 'PATCH',
    baseURL,
    url: `/sales-order/${id}`,
    data,
  })

  return response?.data
}

export const transition = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/sales-order/${id}/transition`,
    data,
  })

  return response?.data
}

export const deleteSingle = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: `/sales-order/${id}`,
  })

  return response?.data
}

export const getHistory = async (id, params) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/sales-order/${id}/history`,
    params,
  })

  return response?.data
}

export const getSuggestions = async (field, queryParam) => {
  const params = {
    'customer-name': queryParam?.customerName || undefined,
  }

  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: `/sales-order/field-suggestion/${field}`,
    params,
  })

  return response?.data
}

export const bulkTransition = async (data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL: process.env.VUE_APP_API_BFF_URL,
    url: `/sales-order/bulk-transition`,
    data,
  })

  return response?.data
}

export const bulkDelete = async (data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL: process.env.VUE_APP_API_BFF_URL,
    url: `/sales-order/bulk-delete`,
    data,
  })

  return response?.data
}

const _getFleetTaskInstant = async (salesOrderId, queryParam, setParams) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
  }

  setParams?.(params)

  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: `/sales-order/${salesOrderId}/fleet-task-instant`,
    params: params,
  })

  return response?.data
}

export const getFleetTaskInstant = (salesOrderId, setParams) => async (queryParam) =>
  await _getFleetTaskInstant(salesOrderId, queryParam, setParams)
